import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isBulkActionsRedesignEnabled"];
import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelectionDispatch, useSelectionSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, getSelectedRowIds, selectQuery } from '../redux/selectionSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkActionsContainerOld(t0) {
  const $ = _c(13);
  const {
    BulkActionsComponent,
    totalRowCount
  } = t0;
  const selectedRowIds = useSelectionSelector(getSelectedRowIds);
  const isQuerySelected = useSelectionSelector(getIsQuerySelected);
  const dispatch = useSelectionDispatch();
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => dispatch(clearSelection());
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clearAllSelections = t1;
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  let t2;
  if ($[2] !== count) {
    t2 = /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.bulkActions.selectionCount",
        options: {
          count
        }
      })
    });
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(Spacer, {
      display: "inline-block",
      space: "200"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== BulkActionsComponent || $[6] !== clearAllSelections || $[7] !== isQuerySelected || $[8] !== selectedRowIds) {
    t4 = /*#__PURE__*/_jsx(BulkActionsComponent, {
      selection: selectedRowIds,
      querySelected: isQuerySelected,
      clearSelection: clearAllSelections
    });
    $[5] = BulkActionsComponent;
    $[6] = clearAllSelections;
    $[7] = isQuerySelected;
    $[8] = selectedRowIds;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      "data-test-id": "bulk-actions-container",
      flexGrow: "1",
      paddingInline: "200",
      children: [t2, t3, t4]
    });
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function BulkActionsContainerNew(t0) {
  const $ = _c(15);
  const {
    paddingBlockEnd,
    BulkActionsComponent,
    isIndexRedesignEnabled,
    showSelectQuery,
    totalRowCount
  } = t0;
  const selectedRowIds = useSelectionSelector(getSelectedRowIds);
  const isQuerySelected = useSelectionSelector(getIsQuerySelected);
  const dispatch = useSelectionDispatch();
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => dispatch(clearSelection());
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clearAllSelections = t1;
  let t2;
  if ($[2] !== dispatch) {
    t2 = () => dispatch(selectQuery());
    $[2] = dispatch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectEverything = t2;
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  const t3 = !isIndexRedesignEnabled;
  let t4;
  if ($[4] !== BulkActionsComponent || $[5] !== clearAllSelections || $[6] !== count || $[7] !== isQuerySelected || $[8] !== paddingBlockEnd || $[9] !== selectEverything || $[10] !== selectedRowIds || $[11] !== showSelectQuery || $[12] !== t3 || $[13] !== totalRowCount) {
    t4 = /*#__PURE__*/_jsx(BulkActionsComponent, {
      paddingBlockEnd: paddingBlockEnd,
      clearSelection: clearAllSelections,
      doNotUseIsBorderless: t3,
      isBulkActionsRedesignEnabled: true,
      onClose: clearAllSelections,
      onSelectQuery: selectEverything,
      querySelected: isQuerySelected,
      selection: selectedRowIds,
      selectionCount: count,
      showSelectQuery: showSelectQuery,
      totalCount: totalRowCount
    });
    $[4] = BulkActionsComponent;
    $[5] = clearAllSelections;
    $[6] = count;
    $[7] = isQuerySelected;
    $[8] = paddingBlockEnd;
    $[9] = selectEverything;
    $[10] = selectedRowIds;
    $[11] = showSelectQuery;
    $[12] = t3;
    $[13] = totalRowCount;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
function BulkActionsContainer(t0) {
  const $ = _c(7);
  let rest;
  let t1;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      isBulkActionsRedesignEnabled: t1
    } = _t);
    rest = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = rest;
    $[2] = t1;
  } else {
    rest = $[1];
    t1 = $[2];
  }
  const isBulkActionsRedesignEnabled = t1 === undefined ? false : t1;
  if (isBulkActionsRedesignEnabled) {
    let t2;
    if ($[3] !== rest) {
      t2 = /*#__PURE__*/_jsx(BulkActionsContainerNew, Object.assign({}, rest));
      $[3] = rest;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== rest) {
    t2 = /*#__PURE__*/_jsx(BulkActionsContainerOld, Object.assign({}, rest));
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export default BulkActionsContainer;